import { formatName, ProfileImage } from '@leland-dev/leland-ui-library';
import Link from 'next/link';
import React from 'react';

import type { Scalars } from '../../__generated-gql-types__/globalTypes';
import { getCoachUrl } from '../../utils/coach';

import type { BookedCoachCardCoachFragment } from './__generated-gql-types__/BookedCoachCard.generated';

interface BookedCoachCardProps {
  bookedCoach: BookedCoachCardCoachFragment;
  categoryUrn: Scalars['CategoryUrn']['output'];
  onClick?: () => void;
}

const BookedCoachCard: React.FC<BookedCoachCardProps> = ({
  bookedCoach,
  categoryUrn,
  onClick,
}) => {
  const categorySpecificHeadline = bookedCoach.categoryInformationList?.find(
    (catInfo) => catInfo.category.id === categoryUrn,
  )?.headline;

  return (
    <Link
      href={getCoachUrl({ coachSlug: bookedCoach.slug, categorySlug: null })}
      className="flex size-full items-center justify-start rounded-xl bg-leland-gray-hover p-4 hover:bg-leland-gray-hover"
      target="_blank"
      rel="noopener noreferrer"
      draggable={false}
      onClick={onClick}
      id="booked_coach_card:coach_profile"
    >
      {bookedCoach.user.pictureLink ? (
        <ProfileImage
          className="mr-2 size-8 shrink-0"
          pictureLink={bookedCoach.user.pictureLink}
          firstName={bookedCoach.user.firstName}
          lastName={bookedCoach.user.lastName}
        />
      ) : null}
      <div className="flex flex-col truncate">
        <p className="text-sm font-medium leading-none text-leland-gray-dark">
          {formatName({
            firstName: bookedCoach.user.firstName,
            lastName: bookedCoach.user.lastName,
          })}
        </p>
        {categorySpecificHeadline ? (
          <p className="truncate text-sm font-normal text-leland-gray-light">
            {categorySpecificHeadline}
          </p>
        ) : null}
      </div>
    </Link>
  );
};

export default BookedCoachCard;
